var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useRouter } from 'next/router';
import React, { createContext, useCallback, useContext, useMemo } from 'react';
var NavigationContext = createContext(undefined);
function sanitizeParams(url) {
    return url.replace(/\/(?=\?)/, '');
}
export var NavigationProvider = function (_a) {
    var children = _a.children;
    var router = useRouter();
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var navigate = useCallback(function (_a) {
        var url = _a.url, _b = _a.shallow, shallow = _b === void 0 ? false : _b, _c = _a.scroll, scroll = _c === void 0 ? true : _c;
        if (shallow) {
            router.push(url, url, { shallow: true, scroll: scroll });
            return;
        }
        if (scroll)
            window.scrollTo(0, 0);
        var sanitisedUrl = sanitizeParams(url);
        window.history.pushState(__assign(__assign({}, window.history.state), { as: sanitisedUrl, url: sanitisedUrl }), '', sanitisedUrl);
        router.push(url, url);
    }, [router]);
    React.useEffect(function () {
        var start = function (_, _a) {
            var shallow = _a.shallow;
            if (!shallow)
                setLoading(true);
        };
        var end = function (_, _a) {
            var shallow = _a.shallow;
            if (!shallow)
                setLoading(false);
        };
        router.events.on('routeChangeStart', start);
        router.events.on('routeChangeComplete', end);
        router.events.on('routeChangeError', end);
        return function () {
            router.events.off('routeChangeStart', start);
            router.events.off('routeChangeComplete', end);
            router.events.off('routeChangeError', end);
        };
    }, [router.events]);
    var navigationContextValue = useMemo(function () {
        return {
            navigate: navigate,
            loading: loading,
        };
    }, [navigate, loading]);
    return (React.createElement(NavigationContext.Provider, { value: navigationContextValue }, children));
};
export function useNavigation() {
    var context = useContext(NavigationContext);
    if (context === undefined) {
        throw new Error("useNavigation must be used within a NavigationProvider Provider");
    }
    return context;
}
